export default {
  data() {
    return {
      bannerList: [],
      showBanner: false
    };
  },
  methods: {
    async getBannerList(isSessionCache) {
      if (isSessionCache) {
        const homeBanner = sessionStorage.getItem('home-banner');
        if (homeBanner) {
          this.bannerList = JSON.parse(homeBanner);
          this.showBanner = true;
          return false;
        }
      }
      const res = await this.$store.dispatch('postData', {
        url: '/api/vpai/recruit/list_banner_used'
      });
      if (res && Array.isArray(res)) {
        const list = res.map(item => ({
          id: item.id,
          title: item.title,
          sort: item.sort,
          imgUrl: item.imgUrl,
          href: this.parseNavigation(item.navigation)
        }));
        // 按 sort 排序
        list.sort((a, b) => a.sort - b.sort);
        if (isSessionCache) {
          sessionStorage.setItem('home-banner', JSON.stringify(list));
        }
        this.bannerList = list;
        this.showBanner = true;
      }
    },
    parseNavigation(navigation) {
      if (!navigation) {
        return 'javascript:;';
      }
      try {
        const nav = JSON.parse(navigation);
        // refType: 1-外链, 其他类型根据业务扩展
        if (nav.refType === 1 && nav.refUrl) {
          return nav.refUrl;
        }
        if (nav.refId) {
          // 根据 refType 和 refId 构建内部链接，可根据业务需求扩展
          return `javascript:;`;
        }
        return 'javascript:;';
      } catch (e) {
        return 'javascript:;';
      }
    }
  }
};
